'use client'

import { type ReactNode } from 'react'

import { ModalContent } from '@src/components/Modal/ModalContent'
import { useModal } from '@src/components/Modal/ModalProvider'
import { getBuilderPreviewMode } from '@src/utils/builder.util'

export interface ModalProps {
  children: ReactNode
  id: string
  isPreviewing?: boolean
  attributes?: any
}

export const Modal = (props: ModalProps) => {
  const { children, id, isPreviewing, attributes } = props
  const { isOpen, setClose } = useModal()
  const isPreviewOpen = Boolean(getBuilderPreviewMode().edit && isPreviewing)
  const open = Boolean(isOpen(id) || isPreviewOpen)

  return (
    <ModalContent
      attributes={attributes}
      isOpen={open}
      onClose={() => {
        setClose(id)
      }}
    >
      {children}
    </ModalContent>
  )
}
